// React
import React, { Component } from "react";

// Styles
import './instructions.css';

// The Instructions component takes an array of instructions and with tabs
// will let the user move the instructions and see their progress
class Instructions extends Component {
    
    constructor(props) {

        super(props);

        this.state = {
            step : 0
        };
    }

/**********************************************************
 *  Helper Functions
 **********************************************************/

    // Given a new step, change instructions to that step
    changeStep = (newStep) => {

        var savedStep = newStep;

        if(newStep < 0)
            savedStep = 0;
        else if(newStep > this.props.instructions.length-1)
            savedStep = this.props.instructions.length-1;
    
        this.setState((prevState,props) => {
            return {
                step : savedStep
            }
        });

    }

    // Returns the properly formatted progress dots
    buildProgressDots = () => {

        var completed = this.state.step === this.props.instructions.length-1 ? 'all-complete' : '';

        return (
            <div className={'progress-dots ' + completed}>
            {
                this.props.instructions.map( (instruction, index) => {

                    if(index < this.state.step) 
                        return (<div key={index} onClick={ () => this.changeStep(index) } className='dot completed-step'></div>);
                    else if(index === this.state.step)
                        return (<div key={index} onClick={ () => this.changeStep(index) } className='dot current-step'></div>);
                    else
                        return (<div key={index} onClick={ () => this.changeStep(index) } className='dot empty-step'></div>);
                
                })
            }
            </div>
        );

    }

/**********************************************************
 *  Render
 **********************************************************/

    render() {

        //console.log('Instructions.render()');

        return (
            <div id='Instructions' className="panel panel-flat bg-theme-700 instructions">
                            
                <div className="panel-heading instructions-heading">

                    <div className='panel-title'>Instructions</div>

                    <div className='step-switcher'>
                        <button type="button" onClick={ () => this.changeStep(this.state.step-1) } className="btn btn-raised bg-blue-400 legitRipple">
                            <span>Prev</span>
                        </button>
                        
                        { this.buildProgressDots() }
                        
                        <button type="button" onClick={ () => this.changeStep(this.state.step+1) } className="btn btn-raised bg-blue-400 legitRipple" disabled={this.state.step === this.props.instructions.length ? true : false}>
                            <span>Next</span>
                        </button>
                    </div>

                    <div className="dropdown">
                        <a type="button" className="btn btn-link dropdown-toggle legitRipple" 
                            data-toggle="dropdown" aria-expanded="true">
                            {this.props.exchange}
                            <span className="caret"></span>
                        </a>
                        <ul className="dropdown-menu dropdown-menu-right">
                            <li onClick={() => this.props.selectExchange('BitTrex')}><a href={null}>BitTrex</a></li>
                            <li onClick={() => this.props.selectExchange('Coinbase')}><a href={null}>Coinbase</a></li>
                            <li onClick={() => this.props.selectExchange('Poloniex')}><a href={null}>Poloniex</a></li>
                        </ul>
                    </div>
                        
                </div>

                <div className="panel-body instructions-body">
                    
                    <div className="instruction-panel" key={this.props.instructions[this.state.step].step}>
                        <div className="instruction">{this.props.instructions[this.state.step].step}</div>
                        <div className="instruction-image">{ this.props.instructions[this.state.step].image !== '' ? <img src={this.props.instructions[this.state.step].image} alt={this.props.exchange + ' Step ' + this.state.step}></img> : null }</div>
                    </div>
                    
                </div>
            </div>
        );
    }

}

export default Instructions;








// WEBPACK FOOTER //
// ./src/Views/ApiKeys/Instructions.js